<template>
  <portal to="overlay-outlet">
    <Panel
      :visible="visible"
      header="Cancel Schedule"
      @close="$emit('close')"
    >
      <div class="p-4">
        <div v-if="isBusy" class="flex justify-center py-8">
          <div class="spinner"></div>
        </div>

        <div v-else-if="previewResult && !previewResult.cancelled && previewResult.warnings && previewResult.warnings.length > 0">
          <div class="mb-4">
            <p class="text-red-600 font-semibold mb-2">
              The following job sheets are currently active and will be cancelled:
            </p>
            <div
              v-for="(warning, i) in previewResult.warnings"
              :key="i"
              class="p-2 mb-1 bg-red-50 border border-red-200 rounded text-sm"
            >
              <span v-for="jsId in warning.job_sheet_ids" :key="jsId">
                Job Sheet: <strong>{{ jsId }}</strong>
              </span>
            </div>
          </div>

          <div class="mb-4">
            <label class="block text-sm font-semibold mb-1">Reason for cancellation:</label>
            <textarea
              v-model="cancellationReason"
              rows="3"
              class="w-full bge-input bge-input-spacing rounded"
              placeholder="Enter reason..."
            ></textarea>
          </div>

          <div class="flex justify-end space-x-3">
            <button
              @click="$emit('close')"
              class="px-4 py-2 border border-gray-300 rounded hover:bg-gray-100 text-gray-700"
            >
              Go Back
            </button>
            <button
              @click="forceCancel"
              :disabled="!cancellationReason.trim()"
              class="px-4 py-2 bg-red-500 hover:bg-red-600 text-white rounded disabled:opacity-50 disabled:cursor-not-allowed"
            >
              Force Cancel
            </button>
          </div>
        </div>

        <div v-else-if="cancelSuccess">
          <div class="text-center py-4">
            <span class="text-green-600 font-semibold text-lg">Schedule cancelled successfully.</span>
          </div>
        </div>

        <div v-else-if="errorMessage">
          <div class="text-red-600 p-4">{{ errorMessage }}</div>
          <div class="flex justify-end">
            <button @click="$emit('close')" class="px-4 py-2 border border-gray-300 rounded hover:bg-gray-100">
              Close
            </button>
          </div>
        </div>
      </div>
    </Panel>
  </portal>
</template>

<script>
import Panel from "@/components/Panel.vue";

export default {
  name: "CancelDialog",
  components: { Panel },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    scheduleId: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      isBusy: false,
      previewResult: null,
      cancellationReason: "",
      cancelSuccess: false,
      errorMessage: null,
    };
  },
  watch: {
    visible(val) {
      if (val && this.scheduleId) {
        this.runPreview();
      } else {
        this.reset();
      }
    },
  },
  methods: {
    reset() {
      this.previewResult = null;
      this.cancellationReason = "";
      this.cancelSuccess = false;
      this.errorMessage = null;
      this.isBusy = false;
    },
    async runPreview() {
      this.isBusy = true;
      this.errorMessage = null;
      try {
        const result = await this.$store.dispatch("schedule/cancelSchedule", {
          scheduleId: this.scheduleId,
          payload: {},
        });
        if (result.schedule && result.schedule.status === "Cancelled") {
          this.cancelSuccess = true;
          setTimeout(() => this.$emit("cancelled"), 1500);
        } else {
          this.previewResult = result;
        }
      } catch (error) {
        this.errorMessage = (error && error.data && error.data.message) || "Failed to cancel schedule.";
      } finally {
        this.isBusy = false;
      }
    },
    async forceCancel() {
      this.isBusy = true;
      this.errorMessage = null;
      try {
        await this.$store.dispatch("schedule/cancelSchedule", {
          scheduleId: this.scheduleId,
          payload: {
            force: true,
            cancellation_reason: this.cancellationReason,
          },
        });
        this.cancelSuccess = true;
        setTimeout(() => this.$emit("cancelled"), 1500);
      } catch (error) {
        this.errorMessage = (error && error.data && error.data.message) || "Failed to force cancel.";
      } finally {
        this.isBusy = false;
      }
    },
  },
};
</script>
